enum SectionEnum {
    OVERVIEW = '#overview',
    SUPPLIER = '#supplier',
    DATES = '#dates',
    FINANCE_ACCOUNT = '#finance_account',
    SERVICES = '#services',
    CONTRACT_SUM = '#contract_sum',
    EXTRA_ALARMS = '#extra_alarms',
    VERIFIED_BY = '#verifiedby',
    SPECIAL_CIRCUMSTANCES = '#special_circumstances',
    FILES_CONTRACT = '#files_contract',
    FILES_CORRESPONDENCE = '#files_correspondence',
    NOTES = '#notes',
    STATUS = '#status',
    LINKED_CONTRACTS = '#linked_contracts',
    CUSTOM_FIELDS = '#custom_fields'
}

export default SectionEnum;